import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FaCheckCircle,
  FaPen,
  FaCreditCard,
  FaClock,
  FaCalendarAlt,
  FaHandHoldingUsd,
  FaGift,
  FaHeart,
  FaShieldAlt,
} from "react-icons/fa";
import { RiArrowDownWideLine } from "react-icons/ri";
import { IoMdCloseCircle } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import bad_weather from "../../assets/bad_weather.gif";

const Checkout0 = ({ data }) => {
  const [isBagOpen, setIsBagOpen] = useState(false);
  const [isPriceOpen, setIsPriceOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isTimeslotModalOpen, setIsTimeslotModalOpen] = useState(false);
  const navigate = useNavigate();
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const user_auto_id = sessionStorage.getItem("accessToken");
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loading, setLoading] = useState(true);
  const isAnyOpen = isBagOpen || isPriceOpen;

  const [name, setName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [area, setArea] = useState("");
  const [addressDetails, setAddressDetails] = useState("");
  const userPincode = sessionStorage.getItem("userPincode");
  const app_logo = sessionStorage.getItem("appLogo");
  const appName = sessionStorage.getItem("appName") || "Grobiz";
  const [logoAvailable, setLogoAvailable] = useState(false);
  const fullLogoUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
  const [pincodeList, setPincodeList] = useState([]);
  const [deliveryMessage, setDeliveryMessage] = useState("");
  const [timeslots, setTimeslots] = useState([]);
  const [selectedTimeslot, setSelectedTimeslot] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [nextSevenDays, setNextSevenDays] = useState([]);
  const [isDeliveryDateEnabled, setIsDeliveryDateEnabled] = useState(false);
  const [deliveryType, setDeliveryType] = useState("Normal Delivery");
  const [selectedDeliveryPrice, setSelectedDeliveryPrice] = useState(null);
  const [checkoutSettings, setCheckoutSettings] = useState(null);
  const [isDonationEnabled, setIsDonationEnabled] = useState(false);
  const [isGiftWrapEnabled, setIsGiftWrapEnabled] = useState(false);
  const [selectedTip, setSelectedTip] = useState(null);
  const [orderPlaceTime, setOrderPlaceTime] = useState(null);
  const [pincodeDeliverySettings, setPincodeDeliverySettings] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");


  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color
      );
    }
  }, []);

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }


  useEffect(() => {
    const fetchDeliverySettings = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_delivery_settings`,
          { admin_auto_id: admin_auto_id }
        );
        if (response.data.status === 1 && response.data.data[0]) {
          const settings = response.data.data[0];
          setIsDeliveryDateEnabled(settings.delivery_date_setting === "On");
          setOrderPlaceTime(settings.order_place_time || null); // Store order_place_time
        } else {
          setIsDeliveryDateEnabled(false);
          setOrderPlaceTime(null);
        }
      } catch (error) {
        console.error("Error fetching delivery settings:", error);
        setIsDeliveryDateEnabled(false);
        setOrderPlaceTime(null);
      }
    };

    const fetchCheckoutSettings = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_checkout_form_ui`,
          {
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
          }
        );
        if (response.data.status === 1) {
          setCheckoutSettings(response.data.getdatalist[0]);
          if (response.data.getdatalist[0].bad_weather_enable === "true") {
            setDeliveryMessage(response.data.getdatalist[0].bad_weather_text);
          }
        } else {
          console.log("API returned an error:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching checkout settings:", error);
      }
    };

    const fetchPincodeDeliverySettings = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_pincode_delivery_setting`,
          { admin_auto_id: admin_auto_id }
        );
        if (response.data.status === 1 && response.data.data[0]) {
          setPincodeDeliverySettings(response.data.data[0]);
        } else {
          console.log("API returned an error:", response.data.msg);

        }
      } catch (error) {
        console.log("Error fetching pincode delivery settings:", error);
      }
    };

    fetchPincodeDeliverySettings();
    fetchDeliverySettings();
    fetchCheckoutSettings();
  }, []);

  const getNextSevenDays = (orderTime) => {
    const dates = [];
    const today = new Date();
    let startOffset = 0;

    if (!orderTime) {
      // If order_place_time is empty or null, start from tomorrow
      startOffset = 1;
    } else {
      // Parse order_place_time (e.g., "9:00 PM")
      const [time, period] = orderTime.split(" ");
      const [hours, minutes] = time.split(":").map(Number);
      let hours24 = hours;
      if (period === "PM" && hours !== 12) hours24 += 12;
      if (period === "AM" && hours === 12) hours24 = 0;

      // Create Date object for order_place_time today
      const orderDateTime = new Date(today);
      orderDateTime.setHours(hours24, minutes, 0, 0);

      // Compare with current time
      const now = new Date();
      if (now > orderDateTime) {
        startOffset = 2; // Skip tomorrow, start from day after
      } else {
        startOffset = 1; // Start from today
      }
    }

    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + startOffset + i);
      dates.push({
        id: i,
        date: date.toISOString().split("T")[0],
        display: date.toLocaleDateString("en-US", {
          weekday: "short",
          day: "numeric",
          month: "short",
        }),
      });
    }
    return dates;
  };

  useEffect(() => {
    setNextSevenDays(getNextSevenDays());
  }, []);

  useEffect(() => {
    const fetchPincodeList = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_pincode_list`,
          {
            admin_auto_id: admin_auto_id,
            user_auto_id: admin_auto_id || user_auto_id,
          }
        );
        if (response.data.status === 1) {
          const pincodes = response.data.get_pincode_list.map(
            (item) => item.pincode
          );
          setPincodeList(pincodes);
        } else {
          console.error("API returned an error:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching pincode list:", error);
      }
    };

    fetchPincodeList();
  }, []);

  useEffect(() => {
    if (app_logo) {
      const fullUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${app_logo}`;
      const img = new Image();
      img.src = fullUrl;
      img.onload = () => setLogoAvailable(true);
      img.onerror = () => setLogoAvailable(false);
    }
  }, [app_logo]);

  const fetchAddresses = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_user_address`,
        {
          admin_auto_id,
          user_auto_id,
          limit: 10,
          page_number: 1,
        }
      );
      setAddresses(res.data.status === 1 ? res.data.user_address_details : []);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  useEffect(() => {
    const fetchTimeslots = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_pincode_deliverytime`,
          {
            admin_auto_id: admin_auto_id,
            app_type_id: app_type_id,
          }
        );
        if (response.data.status === 1) {
          setTimeslots(response.data.get_pincode_list);
        } else {
          console.log("API returned an error:", response.data.msg);

        }
      } catch (error) {
        console.error("Error fetching timeslots:", error);
      }
    };

    fetchTimeslots();
  }, []);

  const handleEditAddress = async (address) => {
    console.log("inside  handleEditAddress");
    if (!address) {
      console.log("No address selected for editing.");
      return;
    }
    setIsUpdating(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/edit_user_address`,
        {
          admin_auto_id: admin_auto_id,
          user_auto_id: user_auto_id,
          address_auto_id: address._id,
          name,
          mobile_no: mobileNo,
          pincode,
          city,
          country: address.country,
          state,
          address_details: addressDetails,
          area,
          address_type: address.address_type,
        }
      );
      if (res.data.status === "1") {
        setIsSidebarOpen(false);
        fetchAddresses();
      } else {
        console.log(res.data.message || "Failed to update address");
      }
    } catch (error) {
      console.log("Error updating address:", error);

    } finally {
      setIsUpdating(false); // Reset updating state
    }
  };

  const handleDeliverHere = (address) => {
    if (pincodeList.includes(address.pincode)) {
      const deliveryData = {
        address,
        ...(selectedDeliveryPrice && { selectedDeliveryPrice }),
        ...(selectedTimeslot && { selectedTimeslot }),
        ...(selectedDate && { selectedDate }),
        ...(deliveryType && { deliveryType }),
        ...(checkoutSettings?.handling_charges_enable === "true" &&
          checkoutSettings?.handling_fee && {
          handlingCharges: checkoutSettings.handling_fee,
        }),
        ...(checkoutSettings?.rain_charges_enable === "true" &&
          checkoutSettings?.rain_surge_charge && {
          rainSurgeCharge: checkoutSettings.rain_surge_charge,
        }),
        ...(isGiftWrapEnabled &&
          checkoutSettings?.gift_charges_enable === "true" &&
          checkoutSettings?.giftwrap_fee && {
          giftWrapFee: checkoutSettings.giftwrap_fee,
        }),
        ...(isDonationEnabled &&
          checkoutSettings?.donation_charges_enable === "true" &&
          checkoutSettings?.donation_fee && {
          donationFee: checkoutSettings.donation_fee,
        }),
        ...(selectedTip && { tip: selectedTip }),
      };
      navigate("/paymentpage", { state: deliveryData });
    } else {
      setDeliveryMessage(
        "We apologize, but delivery is currently unavailable to this location. Please select a different address or contact support for assistance."
      );
      setTimeout(() => {
        setDeliveryMessage("");
      }, 3000);
    }
  };

  useEffect(() => {
    if (selectedAddress) {
      setName(selectedAddress.name || "");
      setMobileNo(selectedAddress.mobile_no || "");
      setPincode(selectedAddress.pincode || "");
      setCity(selectedAddress.city || "");
      setState(selectedAddress.state || "");
      setArea(selectedAddress.area || "");
      setAddressDetails(selectedAddress.address_details || "");
    }
  }, [selectedAddress]);

  const filteredTimeslots = timeslots.filter(
    (slot) =>
      slot.pincode === userPincode && slot.normal_or_express === deliveryType
  );

  const handleTimeslotSelect = (slot) => {
    const time =
      deliveryType === "Normal Delivery"
        ? `${slot.from_time}-${slot.to_time}`
        : slot.express_time;
    setSelectedTimeslot(time);
    setSelectedDeliveryPrice(slot.delivery_price);
  };

  const calculateTotalPaidPrice = () => {
    let total = parseFloat(data?.total_paid_price) || 0;
    if (checkoutSettings?.handling_charges_enable === "true") {
      total += parseFloat(checkoutSettings.handling_fee) || 0;
    }
    if (checkoutSettings?.rain_charges_enable === "true") {
      total += parseFloat(checkoutSettings.rain_surge_charge) || 0;
    }
    if (
      isDonationEnabled &&
      checkoutSettings?.donation_charges_enable === "true"
    ) {
      total += parseFloat(checkoutSettings.donation_fee) || 0;
    }
    if (isGiftWrapEnabled && checkoutSettings?.gift_charges_enable === "true") {
      total += parseFloat(checkoutSettings.giftwrap_fee) || 0;
    }
    if (selectedTip) {
      total += parseFloat(selectedTip) || 0;
    }
    if (selectedDeliveryPrice) {
      total += parseFloat(selectedDeliveryPrice) || 0;
    }
    return total.toFixed(2);
  };

  // Calculate total delivery charge
  const totalDeliveryCharge = selectedDeliveryPrice
    ? Number(data?.pincode_delivery_charge || 0) + Number(selectedDeliveryPrice)
    : Number(data?.pincode_delivery_charge || 0);

  const tipValues = checkoutSettings?.tip_values
    ? checkoutSettings.tip_values.split(",")
    : ["10", "20", "30", "50"];

  // Normalize the return policy link to ensure it starts with https://
  const normalizedReturnPolicyLink = checkoutSettings?.return_policy_link
    ? checkoutSettings.return_policy_link.match(/^https?:\/\//)
      ? checkoutSettings.return_policy_link
      : `https://${checkoutSettings.return_policy_link}`
    : "#";

  // Determine if the "Select Date and Time" button should be shown
  const showTimeslotButton = !(
    pincodeDeliverySettings?.delivery_type === "pincode" &&
    isDeliveryDateEnabled === false
  );

  return (
    <div className="min-h-screen py-6 font-sans bg-white">

      <header className="flex items-center justify-center pt-2 pb-3 border-b">
        {logoAvailable ? (
          <img src={fullLogoUrl} alt={appName} className="h-14 pl-14" />
        ) : (
          appName
        )}
        <nav className="items-center justify-center hidden w-full pt-2 pb-2 space-x-6 md:flex">
          <div className="flex items-center space-x-2">
            <FaCheckCircle className=" h-7 w-7"
              style={{ color: darkenHexColor(themeIconColor, 0.15) }} />
            <span className="text-gray-500">Sign Up</span>
          </div>
          <div className="w-72 h-0.5 bg-gray-300"></div>
          <div className="flex items-center space-x-2">
            <FaPen className="w-6 h-6 " style={{ color: darkenHexColor(themeIconColor, 0.15) }} />
            <span className="font-semibold text-black">Address</span>
          </div>
          <div className="w-72 h-0.5 bg-gray-300"></div>
          <div className="flex items-center space-x-2">
            <FaCreditCard className=" h-7 w-7"
              style={{ color: lightenHexColor(themeIconColor, 0.2) }} />
            <span className="text-gray-500">Payment</span>
          </div>
        </nav>
      </header>
      {deliveryMessage && (
        <div className="flex flex-col items-center p-4 mb-4 rounded-lg shadow-sm bg-gray-50">
          {checkoutSettings?.bad_weather_enable === "true" && (
            <img
              src={bad_weather}
              alt="Bad Weather"
              className="object-cover w-24 h-24 mb-2"
            />
          )}
          <p className="font-semibold text-center text-red-600">
            {deliveryMessage}
          </p>
        </div>
      )}
      <main className="sm:p-2 md:mt-4 md:mx-10">
        <h1 className="p-2 font-semibold">Choose Address</h1>
        <p className="p-2 mb-10 text-gray-500">
          Detailed address will help our delivery partner reach your doorstep
          quickly
        </p>

        <div className="flex-col gap-6 p-4 sm:flex md:flex-row">
          <div className="flex-col w-full gap-6 p-0 sm:flex md:flex-row">
            <div className="w-full">
              <div className="grid w-full grid-cols-1 gap-2 sm:grid-cols-3">
                <div
                  className="flex flex-col items-center justify-center w-full h-56 col-span-1 py-10 transition border border-gray-300 cursor-pointer hover:bg-slate-100"
                  onClick={() =>
                    navigate("/dashboard", { state: { page: "myaddress" } })
                  }
                >
                  <span className="text-4xl">+</span>
                  <p className="font-semibold text-black">Add New Address</p>
                </div>

                {loading && (
                  <div className="flex items-center justify-center w-full h-56 col-span-2 text-gray-500 border border-gray-300">
                    <div className="flex flex-col items-center">
                      <svg
                        className="w-8 h-8 mr-3 animate-spin"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      <p className="mt-2">Loading addresses...</p>
                    </div>
                  </div>
                )}

                {!loading && addresses.length === 0 && (
                  <div className="flex flex-col items-center justify-center w-full h-56 col-span-2 text-gray-500 border border-gray-300">
                    <svg
                      className="w-12 h-12 mb-4 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                      ></path>
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                    <p className="text-lg font-medium">No addresses found</p>
                    <p className="text-sm">
                      Add your first address by clicking the card
                    </p>
                  </div>
                )}

                {!loading &&
                  addresses.length > 0 &&
                  addresses.map((address, index) => (
                    <div
                      key={address._id}
                      className="w-full h-56 p-2 transition border border-gray-300 hover:bg-slate-100"
                    >
                      <div className="flex justify-between">
                        <p className="font-semibold capitalize">
                          {address.address_type}
                        </p>
                      </div>
                      <p className="mt-1 mb-0 text-gray-500 capitalize">
                        {address.flat_no} {address.wing_block_phase}{" "}
                        {address.address_details}, {address.area},{" "}
                        {address.state}
                      </p>
                      <p className="mb-0 text-gray-500 capitalize">
                        {address.city}-{address.pincode}
                      </p>
                      <p className="mb-0 text-gray-500 ">{address.mobile_no}</p>
                      <div className="flex space-x-4 sm:mt-2 md:mt-4">
                        <button
                          className="px-4 py-2 border border-gray-400 sm:py-1 hover:bg-gray-100"
                          onClick={() => {
                            setSelectedAddress(address);
                            setIsSidebarOpen(true);
                          }}
                        >
                          Edit
                        </button>
                        <button
                          className="px-4 py-2 text-white disabled:cursor-not-allowed"
                          onClick={() => {
  setSelectedAddress(address);
  setIsTimeslotModalOpen(true);
}}
                         disabled={checkoutSettings?.bad_weather_enable === "true"}
                          style={{
                            backgroundColor: checkoutSettings?.bad_weather_enable === "true"
                              ? "rgb(156, 163, 175)" // gray-400
                              : themeColor,
                          }}
                          onMouseEnter={(e) => {
                            if (!checkoutSettings?.bad_weather_enable) {
                              e.currentTarget.style.backgroundColor = darkenHexColor(themeColor, 0.15);
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!checkoutSettings?.bad_weather_enable) {
                              e.currentTarget.style.backgroundColor = themeColor;
                            }
                          }}
                        >
                          Deliver here
                        </button>

                      </div>
                    </div>
                  ))}
              </div>

              {(checkoutSettings?.donation_charges_enable === "true" ||
                checkoutSettings?.gift_charges_enable === "true" ||
                checkoutSettings?.tip_enable === "true") && (
                  <div className="p-4 mt-6 bg-white border border-gray-200 shadow-sm rounded-xl">
                    <h2
                      className="flex items-center mb-6 text-xl font-bold text-gray-800 whitespace-nowrap max-md:text-lg"
                    >
                      <FaHandHoldingUsd
                        className="w-6 h-6 mr-2"
                        style={{ color: themeIconColor }}
                      />
                      Additional Charges & Options
                    </h2>


                    {checkoutSettings?.donation_charges_enable === "true" && (
                      <div className="flex items-center justify-between py-3 border-b border-gray-200">
                        <div className="flex items-center">
                          <button
                            className={`relative inline-flex items-center h-6 w-11 rounded-full mr-3 transition-colors duration-200 focus:outline-none ${isDonationEnabled ? "" : "bg-gray-300"
                              }`}
                            style={{
                              backgroundColor: isDonationEnabled ? themeColor : undefined,
                            }}
                            onClick={() =>
                              setIsDonationEnabled(!isDonationEnabled)
                            }
                          >
                            <span
                              className={`inline-block h-4 w-4 bg-white rounded-full transform transition-transform duration-200 ${isDonationEnabled
                                  ? "translate-x-6"
                                  : "translate-x-1"
                                }`}
                            />
                          </button>
                          <FaHeart className="w-5 h-5 mr-3 text-red-500" />
                          <span className="text-base text-gray-700">
                            Add Donation
                          </span>
                        </div>
                        {isDonationEnabled && (
                          <span className="text-base font-semibold text-gray-800">
                            ₹{checkoutSettings.donation_fee}
                          </span>
                        )}
                      </div>
                    )}

                    {checkoutSettings?.gift_charges_enable === "true" && (
                      <div className="flex items-center justify-between py-3 border-b border-gray-200">
                        <div className="flex items-center">
                          <button
                            className={`relative inline-flex items-center h-6 w-11 rounded-full mr-3 transition-colors duration-200 focus:outline-none ${isGiftWrapEnabled ? "" : "bg-gray-300"
                              }`}
                            style={{
                              backgroundColor: isGiftWrapEnabled ? themeColor : undefined,
                            }}
                            onClick={() =>
                              setIsGiftWrapEnabled(!isGiftWrapEnabled)
                            }
                          >
                            <span
                              className={`inline-block h-4 w-4 bg-white rounded-full transform transition-transform duration-200 ${isGiftWrapEnabled
                                  ? "translate-x-6"
                                  : "translate-x-1"
                                }`}
                            />
                          </button>
                          <FaGift className="w-5 h-5 mr-3 text-purple-500" />
                          <span className="text-base text-gray-700">
                            Add Gift Wrap
                          </span>
                        </div>
                        {isGiftWrapEnabled && (
                          <span className="text-base font-semibold text-gray-800">
                            ₹{checkoutSettings.giftwrap_fee}
                          </span>
                        )}
                      </div>
                    )}

                    {checkoutSettings?.tip_enable === "true" &&
                      tipValues.length > 0 && (
                        <div className="mt-6">
                          <div className="flex items-center mb-3">
                            <FaHandHoldingUsd className="w-5 h-5 mr-3"
                              style={{ color: themeIconColor }} />
                            <h3 className="text-base font-semibold text-gray-800">
                              {checkoutSettings?.tip_title ||
                                "Support Your Delivery Partner"}
                            </h3>
                          </div>
                          <p className="flex items-center mb-4 text-sm text-gray-600">
                            {checkoutSettings?.tip_description ||
                              "Add a tip to show appreciation for your delivery partner"}
                          </p>
                          {checkoutSettings?.tip_image ? (
                            <img
                              src={checkoutSettings.tip_image}
                              alt="Tip"
                              className="object-cover w-20 h-20 mb-4 border border-gray-200 rounded-lg"
                            />
                          ) : (
                            <div className="flex items-center justify-center w-20 h-20 mb-4 bg-gray-100 rounded-lg">
                              <FaHandHoldingUsd className="w-10 h-10 text-gray-400" />
                            </div>
                          )}
                          <div
                            className="grid grid-cols-4 gap-3 md:grid-cols-4"
                          >
                            {tipValues.map((value, index) => (
                              <button
                                key={index}
                                className={` 
        px-3 py-1              
        md:px-4 md:py-2          

        border-2 rounded-lg 
        text-sm md:text-base     /* slightly smaller text on mobile */
        font-medium transition-all
        flex items-center justify-center
        ${selectedTip === value
                                    ? "shadow-md"
                                    : "border-gray-200 hover:bg-gray-100 text-gray-700"
                                  }`}
                                style={
                                  selectedTip === value
                                    ? {
                                      borderColor: darkenHexColor(themeColor, 0.2),
                                      backgroundColor: lightenHexColor(themeColor, 0.2),
                                      color: darkenHexColor(themeColor, 0.3),
                                    }
                                    : {}
                                }
                                onClick={() =>
                                  setSelectedTip(selectedTip === value ? null : value)
                                }

                              >
                                ₹{value}
                              </button>
                            ))}

                            {/* <button
    className={` 
      px-3 py-1              
      md:px-4 md:py-2          

      border-2 rounded-lg 
      text-sm md:text-base
      font-medium transition-all
      flex items-center justify-center
      ${
        selectedTip === null
          ? "shadow-md"
          : "border-gray-200 hover:bg-gray-100 text-gray-700"
      }`}
    style={
      selectedTip === null
        ? {
            borderColor: darkenHexColor(themeColor, 0.2),
            backgroundColor: lightenHexColor(themeColor, 0.2),
            color: darkenHexColor(themeColor, 0.3),
          }
        : {}
    }
    onClick={() => setSelectedTip(null)}
  >
    No Tip
  </button> */}
                          </div>

                        </div>
                      )}
                  </div>
                )}

              {checkoutSettings?.return_policy_enable === "true" && (
                <div className="p-4 mt-6 transition-shadow duration-300 rounded-lg shadow-sm bg-gray-50 hover:shadow-md">
                  <div className="flex items-center mb-3">
                    <FaShieldAlt className="w-6 h-6 mr-3" style={{ color: themeIconColor }} />
                    <h3 className="text-lg font-semibold text-gray-800">
                      Hassle-Free Returns
                    </h3>
                  </div>
                  <p className="mb-4 text-sm leading-relaxed text-gray-600">
                    {checkoutSettings.return_policy_text ||
                      "We offer easy returns and exchanges to ensure your satisfaction."}
                  </p>
                  <a
                    href={normalizedReturnPolicyLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 text-sm font-medium text-white no-underline transition-colors duration-200 rounded-md hover:underline"
                    style={{ backgroundColor: themeColor }}
                    onMouseEnter={(e) => {
                      const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                      e.currentTarget.style.backgroundColor = darkenedColor;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = themeColor;
                    }}
                  >
                    View Return Policy
                    <svg
                      className="w-4 h-4 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      ></path>
                    </svg>
                  </a>
                </div>
              )}
            </div>
          </div>

          <div className="flex flex-col w-full md:w-[500px]">
            {showTimeslotButton && (
              <button
                className="flex items-center justify-center w-full gap-2 py-2 mb-4 text-white rounded"
                onClick={() => setIsTimeslotModalOpen(true)}
                style={{ backgroundColor: themeColor }}
                onMouseEnter={(e) => {
                  const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                  e.currentTarget.style.backgroundColor = darkenedColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = themeColor;
                }}
              >
                <FaClock className="w-5 h-5" />
                Select Date and Time
              </button>
            )}

            <div className="px-2 pt-4 transition-all duration-300 border">
              {/* ================= BAG ================= */}
              <div className="pb-2 mb-2 border-b">
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => setIsBagOpen(!isBagOpen)}
                >
                  <h3 className="text-lg font-semibold">Bag</h3>
                  <div className="flex items-center">
                    {!isBagOpen && (
                      <span>
                        {data?.get_admin_cart_product_lists?.length} Items
                      </span>
                    )}
                    <RiArrowDownWideLine
                      className={`ml-2 transition-transform ${isBagOpen ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                </div>

                {isBagOpen &&
                  data?.get_admin_cart_product_lists?.map((item, idx) => {
                    const selectedSizeName =
                      item?.user_seleted_size &&
                      item?.size?.find(
                        (s) => s.size_auto_id === item.user_seleted_size
                      )?.size_name;

                    return (
                      <div
                        key={idx}
                        className="flex items-center justify-between gap-1 mt-2 text-black"
                      >
                        <img
                          src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images?.[0]?.image_file}`}
                          alt={item.product_name}
                          className="object-cover w-10 h-10"
                        />
                        <span className="flex flex-col">
                          {item.product_name}
                          <span className="text-xs">
                            {selectedSizeName || "Free Size"}
                            {item.color_name ? ` | ${item.color_name}` : ""}
                          </span>
                        </span>
                      </div>
                    );
                  })}
              </div>

              {/* ================= PRICE DETAILS ================= */}
              <div className="pb-2">
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => setIsPriceOpen(!isPriceOpen)}
                >
                  <span className="font-semibold">Price Details</span>
                  <div className="flex items-center">
                    {!isPriceOpen && <span>₹{calculateTotalPaidPrice()}</span>}
                    <RiArrowDownWideLine
                      className={`ml-2 transition-transform ${isPriceOpen ? "rotate-180" : ""
                        }`}
                    />
                  </div>
                </div>

                {isPriceOpen && (
                  <div className="mt-2">
                    <div className="flex justify-between mt-4">
                      <span className="text-xs">
                        Bag MRP ({data?.get_admin_cart_product_lists?.length} items)
                      </span>
                      <span className="text-xs font-semibold">
                        ₹{data?.total_price}
                      </span>
                    </div>

                    <div className="flex justify-between mt-4">
                      <span className="text-xs">Delivery Charges</span>
                      <span className="text-xs text-green-600">
                        ₹{totalDeliveryCharge || "0"}
                      </span>
                    </div>

                    {/* ===== TAX EXCLUSIVE PRODUCTS ===== */}
                    {data?.get_admin_cart_product_lists?.some(
                      (item) => item.including_tax === "No"
                    ) && (
                        <div className="mt-3 space-y-1">
                          {data?.get_admin_cart_product_lists
                            ?.filter((item) => item.including_tax === "No")
                            .map((item, idx) => (
                              <div
                                key={idx}
                                className="flex justify-between text-xs text-gray-600"
                              >
                                <span>{item.product_name} (GST Extra)</span>
                                <span>₹{item.final_product_price}</span>
                              </div>
                            ))}
                          <p className="text-[11px] text-gray-500">
                            * GST will be added at checkout for the above item(s)
                          </p>
                        </div>
                      )}

                    {checkoutSettings?.handling_charges_enable === "true" && (
                      <div className="flex justify-between mt-2">
                        <span className="text-xs">Handling Charges</span>
                        <span className="text-xs font-semibold">
                          ₹{checkoutSettings.handling_fee}
                        </span>
                      </div>
                    )}

                    {checkoutSettings?.rain_charges_enable === "true" && (
                      <div className="flex justify-between mt-2">
                        <span className="text-xs">Rain Surge Charge</span>
                        <span className="text-xs font-semibold">
                          ₹{checkoutSettings.rain_surge_charge}
                        </span>
                      </div>
                    )}

                    {isDonationEnabled &&
                      checkoutSettings?.donation_charges_enable === "true" && (
                        <div className="flex justify-between mt-2">
                          <span className="text-xs">Donation</span>
                          <span className="text-xs font-semibold">
                            ₹{checkoutSettings.donation_fee}
                          </span>
                        </div>
                      )}

                    {isGiftWrapEnabled &&
                      checkoutSettings?.gift_charges_enable === "true" && (
                        <div className="flex justify-between mt-2">
                          <span className="text-xs">Gift Wrap Fee</span>
                          <span className="text-xs font-semibold">
                            ₹{checkoutSettings.giftwrap_fee}
                          </span>
                        </div>
                      )}

                    {selectedTip && (
                      <div className="flex justify-between mt-2">
                        <span className="text-xs">Tip</span>
                        <span className="text-xs font-semibold">₹{selectedTip}</span>
                      </div>
                    )}

                    <div className="flex justify-between mt-4">
                      <span className="text-xl font-semibold">You Pay</span>
                      <span className="text-xl font-semibold">
                        <span className="pr-1 text-sm font-normal text-black line-through">
                          ₹{data?.total_price}
                        </span>
                        ₹{calculateTotalPaidPrice()}
                      </span>
                    </div>
                  </div>
                )}
              </div>

              <p className="flex justify-center p-2 mt-6 mb-0 text-sm text-green-600 bg-green-100">
                You are saving ₹{data?.total_saved_amount}.
              </p>
            </div>

            <div className="flex items-center p-3 mt-4 space-x-2 bg-gray-100">
              <p className="text-sm text-gray-500">
                Buy authentic products. Pay securely. Easy returns and exchange
              </p>
            </div>
          </div>
        </div>
      </main>

      {isTimeslotModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="relative w-full max-w-md p-6 bg-white rounded-lg shadow-2xl">
            <button
              className="absolute text-gray-500 top-4 right-4 hover:text-gray-700"
              onClick={() => setIsTimeslotModalOpen(false)}
            >
              <IoMdCloseCircle size={24} />
            </button>

            {pincodeDeliverySettings?.delivery_type !== "pincode" && (
              <>
                <div className="flex items-center gap-2 mb-4">
                  <FaClock className="w-6 h-6 text-black" />
                  <h2 className="text-xl font-semibold text-gray-800">
                    Select Delivery Timeslot
                  </h2>
                </div>{" "}
                <div className="mb-6">
                  <h3 className="mb-2 text-lg font-semibold text-gray-800">
                    Delivery Type
                  </h3>
                  <div className="grid grid-cols-2 gap-3">
                    <div
                      className={`px-4 py-2 border-2 rounded cursor-pointer text-sm text-center transition-all ${deliveryType === "Normal Delivery"
                          ? " text-black font-semibold"
                          : "border-gray-300 hover:bg-gray-100"
                        }`}
                      style={
                        deliveryType === "Normal Delivery"
                          ? {
                            borderColor: darkenHexColor(themeColor, 0.2),
                            backgroundColor: lightenHexColor(themeColor, 0.15),
                          }
                          : {}
                      }
                      onClick={() => setDeliveryType("Normal Delivery")}
                    >
                      Normal Delivery
                    </div>
                    <div
                      className={`px-4 py-2 border-2 rounded cursor-pointer text-sm text-center transition-all ${deliveryType === "Express Delivery"
                          ? " text-black font-semibold"
                          : "border-gray-300 hover:bg-gray-100"
                        }`}
                      style={
                        deliveryType === "Express Delivery"
                          ? {
                            borderColor: darkenHexColor(themeColor, 0.2),
                            backgroundColor: lightenHexColor(themeColor, 0.15),
                          }
                          : {}
                      }
                      onClick={() => setDeliveryType("Express Delivery")}
                    >
                      Express Delivery
                    </div>
                  </div>
                </div>
                <div className="mb-6">
                  <h3 className="mb-2 text-lg font-semibold text-gray-800">
                    Delivery Timeslot
                  </h3>
                  {filteredTimeslots.length === 0 ? (
                    <p className="text-center text-gray-500">
                      No {deliveryType.toLowerCase()} timeslots available for
                      pincode {userPincode}
                    </p>
                  ) : (
                    <div className="grid grid-cols-2 gap-3">
                      {filteredTimeslots.map((slot) => (
                        <div
                          key={slot._id}
                          className={`px-4 py-2 border-2 rounded cursor-pointer text-sm text-center transition-all ${selectedTimeslot ===
                              (deliveryType === "Normal Delivery"
                                ? `${slot.from_time}-${slot.to_time}`
                                : slot.express_time)
                              ? " text-black font-semibold"
                              : "border-gray-300 hover:bg-gray-100"
                            }`}
                          style={
                            selectedTimeslot ===
                              (deliveryType === "Normal Delivery"
                                ? `${slot.from_time}-${slot.to_time}`
                                : slot.express_time)
                              ? {
                                borderColor: darkenHexColor(themeColor, 0.2),
                                backgroundColor: lightenHexColor(themeColor, 0.15),
                              }
                              : {}
                          }
                          onClick={() => handleTimeslotSelect(slot)}
                        >
                          <div>
                            {deliveryType === "Normal Delivery"
                              ? `${slot.from_time}-${slot.to_time}`
                              : slot.express_time}
                          </div>
                          <div className="text-xs text-gray-600">
                            extra delivery charge: ₹{slot.delivery_price}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
            {isDeliveryDateEnabled && (
              <>
                <div className="flex items-center gap-2 mb-4">
                  <FaCalendarAlt className="w-6 h-6 text-black" />
                  <h2 className="text-xl font-semibold text-gray-800">
                    Select Delivery Date
                  </h2>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {nextSevenDays.map((day) => (
                    <div
                      key={day.id}
                      className={`px-4 py-2 border-2 rounded cursor-pointer text-sm text-center transition-all ${selectedDate === day.date
                          ? " text-black font-semibold"
                          : "border-gray-300 hover:bg-gray-100"
                        }`}
                      style={
                        selectedDate === day.date
                          ? {
                            borderColor: darkenHexColor(themeColor, 0.2),
                            backgroundColor: lightenHexColor(themeColor, 0.15),
                          }
                          : {}
                      }
                      onClick={() => setSelectedDate(day.date)}
                    >
                      {day.display}
                    </div>
                  ))}
                </div>
              </>
            )}
            <button
              className="w-full py-2 mt-6 text-white transition-colors rounded-lg"
              onClick={() => {
  setIsTimeslotModalOpen(false);
  handleDeliverHere(selectedAddress);
}}
              style={{ backgroundColor: themeColor }}
              onMouseEnter={(e) => {
                const darkenedColor = darkenHexColor(themeColor, 0.15); // darken by 15%
                e.currentTarget.style.backgroundColor = darkenedColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = themeColor;
              }}
            >
              Confirm Selection
            </button>
          </div>
        </div>
      )}

      {isSidebarOpen &&
        selectedAddress && (
          <div className="fixed inset-0 flex justify-end bg-black bg-opacity-50">
            <div className="w-full h-full p-6 pb-20 overflow-auto bg-white md:w-96">
              <div className="flex items-center justify-start border-b-2">
                <button
                  className="pr-5 mb-2 text-right"
                  onClick={() => {
                    setIsSidebarOpen(false);
                    setSelectedAddress(null); // Clear selectedAddress when closing sidebar
                  }}
                >
                  <IoMdCloseCircle size={28} color="#c4c4c4" />
                </button>
                <h2 className="text-xl font-bold">Edit Address</h2>
              </div>
              <div className="mt-4 bg-gray-200 rounded-lg">
                <label className="block pl-2 text-xs">Pincode</label>
                <input
                  className="w-full p-2 bg-gray-200 rounded-b-lg shadow-md"
                  value={pincode}
                  onChange={(e) => setPincode(e.target.value)}
                />
              </div>
              <div className="flex mt-4 space-x-2">
                <div className="w-1/2">
                  <label className="block pl-2 text-xs bg-gray-200 rounded-t-lg shadow-md">
                    City
                  </label>
                  <input
                    className="w-full p-2 bg-gray-200 rounded-b-lg"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
                <div className="w-1/2">
                  <label className="block pl-2 text-xs bg-gray-200 rounded-t-lg shadow-md">
                    State
                  </label>
                  <input
                    className="w-full p-2 bg-gray-200 rounded-b-lg"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                </div>
              </div>
              <div className="mt-4">
                <label className="block pl-2 text-xs bg-gray-200 rounded-t-lg shadow-md">
                  Area
                </label>
                <input
                  className="w-full p-2 bg-gray-200 rounded-b-lg"
                  value={area}
                  onChange={(e) => setArea(e.target.value)}
                />
              </div>
              <div className="mt-4">
                <label className="block pl-2 text-xs bg-gray-200 rounded-t-lg shadow-md">
                  Road Name/Area/Colony
                </label>
                <textarea
                  className="w-full p-2 bg-gray-200 rounded-b-lg"
                  value={addressDetails}
                  onChange={(e) => setAddressDetails(e.target.value)}
                />
              </div>

              <h3 className="mt-6 font-semibold">Contact</h3>
              <p className="pt-0 mt-0 text-xs text-gray-400">
                Information provided here will be used to contact you for
                delivery updates
              </p>
              <div className="mt-4">
                <label className="block pl-2 text-xs bg-gray-200 rounded-t-lg shadow-md">
                  Name
                </label>
                <input
                  className="w-full p-2 bg-gray-200 rounded-b-lg"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="mt-2">
                <label className="block pl-2 text-xs bg-gray-200 rounded-t-lg shadow-md">
                  Phone
                </label>
                <input
                  className="w-full p-2 bg-gray-200 rounded-b-lg"
                  value={mobileNo}
                  onChange={(e) => setMobileNo(e.target.value)}
                />
              </div>
              <button
                className={`w-full p-2 mt-6 text-white rounded transition duration-300 ${isUpdating ? "bg-gray-400 cursor-not-allowed" : ""
                  }`}
                style={!isUpdating ? { backgroundColor: themeColor } : {}}
                onMouseEnter={(e) => {
                  if (!isUpdating) {
                    const darkenedColor = darkenHexColor(themeColor, 0.15);
                    e.currentTarget.style.backgroundColor = darkenedColor;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isUpdating) {
                    e.currentTarget.style.backgroundColor = themeColor;
                  }
                }}
                onClick={() => handleEditAddress(selectedAddress)}
                disabled={isUpdating}
              >
                {isUpdating ? "Updating" : "Update Address"}
              </button>

            </div>
          </div>
        )}
    </div>
  );
};

export default Checkout0;

